var _defs, _circle, _polygon;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEngine(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "engineJrPanel",
    "data-name": "Engine Jr Panel",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 138 138",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".Engine-cls-1{fill:#14163d;}.Engine-cls-2{fill:#fff;}"))), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    className: "Engine-cls-1",
    cx: 69,
    cy: 69,
    r: 69
  })), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    className: "Engine-cls-2",
    points: "70.87 74.56 51.46 73.59 106.79 115.33 74.27 81.84 95.62 84.75 66.5 60.48 81.06 60.48 32.53 19.71 59.71 51.75 43.21 51.75 70.87 74.56"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEngine);
export default __webpack_public_path__ + "static/media/Engine.4db5cfe3ff0cf3064f35936d5d0a88af.svg";
export { ForwardRef as ReactComponent };